import { Reveal, Eyebrow } from "@/components/Reveal";

const STRENGTHS = [
  {
    id: "tilannetajuinen",
    title: "Tilannetajuinen",
    desc: "Osaan huomioida nopeasti muuttuvat tilanteet ja toimia rauhallisesti niiden mukaan.",
  },
  {
    id: "luonteva",
    title: "Luonteva lasten kanssa",
    desc: "Tulen lasten kanssa luontevasti toimeen ja osaan kohdata heidät heidän omalla tasollaan.",
  },
  {
    id: "laaja",
    title: "Laaja kokemus",
    desc: "Kokemusta eri-ikäisistä lapsista sekä säännöllisestä viikoittaisesta lastenhoidosta.",
  },
  {
    id: "joustava",
    title: "Joustava",
    desc: "Uuden perheen tavat, rutiinit ja toiveet omaksun nopeasti.",
  },
];

export const Strengths = () => (
  <section id="vahvuudet" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-12 sm:mb-14">
        <Reveal>
          <Eyebrow index="03" label="Vahvuudet" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 font-serif text-4xl font-medium tracking-tight text-petrol-night sm:text-5xl">
            Neljä vahvuuttani
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STRENGTHS.map((s, i) => (
          <Reveal key={s.id} delay={0.08 * i} className="h-full">
            <div
              data-testid={`strength-card-${s.id}`}
              className="group flex h-full flex-col rounded-[1.5rem] border border-line bg-greige/60 p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-petrol/30 hover:bg-cream hover:shadow-[0_25px_50px_-25px_rgba(18,58,62,0.3)]"
            >
              <span className="font-serif text-sm italic text-beige-deep">0{i + 1}</span>
              <h3 className="mt-5 font-serif text-2xl font-semibold leading-tight text-petrol-night">
                {s.title}
              </h3>
              <p className="mt-4 text-[0.95rem] leading-relaxed text-mutedink">{s.desc}</p>
              <span className="mt-auto block h-px w-8 bg-beige-deep/60 pt-0 transition-all duration-500 group-hover:w-full group-hover:bg-petrol/30 [margin-top:1.75rem]" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
